import Vue from 'vue';
import Vuex from 'vuex';

import { questionModule } from './modules/question-store';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    question: questionModule,
  },
  strict: debug
});
